<script lang="ts" setup>
  import { PropType } from "vue";

  import { Operator } from "frontend/interfaces/settings/operator";

  defineProps({
    operator: {
      type: Object as PropType<Operator>,
      required: true,
    },
  });
</script>

<template>
  <span>
    <span
      v-if="operator && operator.abbreviation"
      v-tooltip="
        operator && operator.name ? `Anwendername: ${operator.name}` : ''
      "
      class="operator-tag"
    >
      {{ operator.abbreviation }}
    </span>
  </span>
</template>

<style lang="scss" scoped>
  @use "shared/styles/colors";

  .operator-tag {
    background-color: colors.$color_operator-tag--background;
    color: colors.$color_operator-tag--text;

    font-size: 10px;
    padding: 2px 5px;
    margin: 0 5px;
  }
</style>
